import { TeamMember } from '@domain/team/team.types';
import { onSortDescByDate } from '@shared/utils/date.utils';
import find from 'lodash/find';

export const getPercentageOfTotal = (subTasks = []) => {
    const completed = subTasks
        .map(subTask => subTask.progress)
        .reduce((a, b) => parseInt(a, 10) + parseInt(b, 10), 0);

    const { length } = subTasks;
    if (length === 0) return 0;

    return Math.ceil((completed / length));
};

export const roundProgressValue = (value) => {
    if (value > 100) {
        return 100;
    }
    if (value < 0) {
        return 0;
    }
    return value;
};

export const formatOptions = team => Object.values(team).map((member: TeamMember) => ({
    data: member,
    label: member.full_name,
    value: member.id.toString(),
}));

export const isTeamMember = (loggedUserId, team) => Object.values(team).filter(
    ({ id: teamMemberId }) => loggedUserId === teamMemberId,
).length > 0;

export const sortByDescDate = (array) => {
    const orderedDates = onSortDescByDate(
        array.map(item => item.created_at),
    );

    return orderedDates.map(date => find(
        array, { created_at: date },
    ));
};
